import { RoleType } from '@ts/core/src/common/constants/role-type'
import { useStore } from '../store/hooks'
import { getUserStores, hasMultipleStores, needsStoreSelection } from '../utils/userStores'

export const useUser = () => {
  const auth = useStore(s => s.auth)
  const user = auth?.user

  const isAdmin = user?.role === RoleType.ADMIN
  const isStoreUser = user?.role === RoleType.USER
  const isImpersonating = !!auth.impersonationToken
  const isLoggedIn = !!user
  const stores = getUserStores(user)
  const userHasMultipleStores = hasMultipleStores(user)
  const userNeedsStoreSelection = needsStoreSelection(user)

  return {
    isAdmin,
    isStoreUser,
    user,
    stores,
    hasMultipleStores: userHasMultipleStores,
    needsStoreSelection: userNeedsStoreSelection,
    isImpersonating,
    isLoggedIn,
    token: auth?.token,
  }
}
